import { useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

// Mapping des routes vers leurs labels et catégories
const routeMap: Record<string, { label: string; category?: 'overview' | 'workspace' | 'more' | 'ai' }> = {
  '/dashboard': { label: 'Home', category: 'overview' },
  '/calendar': { label: 'Calendar', category: 'overview' },
  '/stats': { label: 'Statistics', category: 'overview' },
  '/assistant': { label: 'Assistant', category: 'ai' },
  '/clients': { label: 'Clients', category: 'workspace' },
  '/orders': { label: 'Orders', category: 'workspace' },
  '/invoices': { label: 'Invoices', category: 'workspace' },
  '/tasks': { label: 'Workboard', category: 'workspace' },
  '/profile': { label: 'Profile', category: 'more' },
  '/settings': { label: 'Settings', category: 'more' },
  '/upgrade': { label: 'Upgrade', category: 'more' },
  '/admin/dashboard': { label: 'Admin', category: 'more' },
};

const categoryLabels: Record<string, string> = {
  overview: 'Overview',
  workspace: 'Workspace',
  more: 'More',
  ai: 'AI',
};

export function useBreadcrumbs(): BreadcrumbItem[] {
  const location = useLocation();
  const pathname = location.pathname;

  // Trouver la route correspondante
  const routeInfo = routeMap[pathname];
  
  if (!routeInfo) {
    // Si la route n'est pas dans le mapping, essayer de trouver une correspondance partielle
    const matchedRoute = Object.keys(routeMap).find(route => pathname.startsWith(route));
    if (matchedRoute) {
      const info = routeMap[matchedRoute];
      return [
        { label: categoryLabels[info.category || 'overview'] || 'Dashboard' },
        { label: info.label, href: matchedRoute },
      ];
    }
    // Route inconnue, retourner juste Dashboard
    return [{ label: 'Dashboard' }, { label: 'Page' }];
  }

  const category = routeInfo.category || 'overview';
  const categoryLabel = categoryLabels[category] || 'Dashboard';

  return [
    { label: categoryLabel },
    { label: routeInfo.label, href: pathname },
  ];
}

